<script>
    import { Tooltip } from "@svelte-plugins/tooltips";
    import { format } from "date-fns";
    import { createEventDispatcher } from "svelte";
    import { functionGetMembershipByYear } from "../../../utils/subscribers";

    export let subscriber;
    export let checked = false;
    export let disabled = false;
    export let referenceYear;

    const maxCharEmail = 20;
    const maxCharName = 12;
    const dispatch = createEventDispatcher();

    function handleSelect(value) {
        dispatch('selected', { state: "Selected toggle", value: value})
    }
</script>

<tr class="border-b h-14 {disabled && 'opacity-75'}">
    <td class="w-16 text-left flex flex-col justify-center items-center h-14">
        <input
            class="cursor-pointer w-6 h-6 disabled:opacity-30 disabled:cursor-default"
            type="checkbox"
            checked="{checked}"
            {disabled}
            on:input={(v) => {handleSelect(v.target.checked)}}
        >
    </td>
    <td class="w-32 {subscriber.firstName.length > maxCharName ? 'scroll-container' : ''}">
        <div class="{subscriber.firstName.length > maxCharName ? 'scroll-text' : ''}">
            {subscriber.firstName}
        </div>
    </td>
    <td class="w-32 {subscriber.lastName.length > maxCharName ? 'scroll-container' : ''}">
        <div class="{subscriber.lastName.length > maxCharName ? 'scroll-text' : ''}">
            {subscriber.lastName}
        </div>
    </td>
    <td class="w-64 {subscriber.email.length > maxCharEmail ? 'scroll-container' : ''}">
        <a href="mailto:{subscriber.email}" class="{subscriber.email.length > maxCharEmail ? 'scroll-text' : ''}">
            {subscriber.email}
        </a>
    </td>
    <td class="w-32 {subscriber.email.length > maxCharEmail ? 'scroll-container' : ''}">
        {functionGetMembershipByYear(subscriber.memberships, referenceYear).group.name}
    </td>
    <td class="w-52">
        <a href="tel:{subscriber.phone.code}{subscriber.phone.number}">
            {subscriber.phone?.code} {subscriber.phone?.number}
        </a>
    </td>
    <td class="w-32 font-450 truncate cursor-pointer">
        <Tooltip
            position="right"
            content={`
            <ul>
                <li>${subscriber.residenceAddress.country}</li>
                <li>${subscriber.residenceAddress.city} ${subscriber.residenceAddress?.province ?? ''}</li>
                <li>${subscriber.residenceAddress.street} ${subscriber.residenceAddress.number}</li>
                <li>${subscriber.residenceAddress.secondary}</li>
            </ul>
        `}>
            {subscriber.residenceAddress.city}
        </Tooltip>
    </td>
    <td class="w-44">
        {(new Date(subscriber.memberships[0].createdAt)).toLocaleDateString('en-GB')}
    </td>
    <td class="w-32">{subscriber.memberships[0]?.paidAt ? format(new Date(subscriber.memberships[0].paidAt), "dd/MM/yyyy") : ""}</td>
    <td class="w-28">{subscriber.memberships[0]?.paidAmount ? `${subscriber.memberships[0]?.paidAmount} €` : ""}</td>
</tr>